import { render, staticRenderFns } from "./PercentageInputWidget.vue?vue&type=template&id=5367e247&scoped=true"
import script from "./PercentageInputWidget.vue?vue&type=script&lang=js"
export * from "./PercentageInputWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5367e247",
  null
  
)

export default component.exports